import React, { useMemo } from 'react';
import styled from 'styled-components';
import { TourItemType } from '@bb/domain/dist/types';

import { createFormatDateFunction } from 'utils';
import { timeFormatter } from '../utils';
import { TourItemContent } from '../types';
import DotSeparator from './DotSeparator';
import { StatusEntry } from '../../../components';

export interface TourShowingStatusProps {
  item: TourItemContent;
}

const shortDateFormatter = createFormatDateFunction('EE, LLLL d');

const TourShowingStatus: React.FC<TourShowingStatusProps> = ({
  item: { status, displayStatus, time, timeEnd, timezone, type },
}) => {
  const suggestedDate = useMemo(
    () => shortDateFormatter(time, timezone),
    [time, timezone],
  );

  const suggestedTime = useMemo(
    () =>
      `${timeFormatter(time, timezone)} - ${timeFormatter(timeEnd, timezone)}`,
    [timeEnd, time, timezone],
  );

  return (
    <StyledTagContainer $draft={type === TourItemType.APPOINTMENT}>
      <StatusEntry
        isBuyer
        showTagOnly
        displayStatus={displayStatus!}
        type={type as 'APPOINTMENT' | undefined}
      />
      {status === 'time_change' && (
        <StyledSuggestedTime>
          {suggestedDate} <DotSeparator /> {suggestedTime}
        </StyledSuggestedTime>
      )}
    </StyledTagContainer>
  );
};

export default TourShowingStatus;

const StyledTagContainer = styled.div<{ $draft: boolean }>`
  margin-top: 5px;
  color: inherit;
  display: flex;

  & .ant-tag {
    border-radius: 2px;
    ${({ $draft }) => $draft && 'color: inherit'}
  }
`;

const StyledSuggestedTime = styled.div`
  font-size: 12px;
`;
